import { getCleanedUrlParams, showError } from '@utils';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { LIMIT } from '@constants';
import { useAssignees } from 'hooks/common';
import { handleExportDataJobsData } from './utils';

const { QUERY_KEYS } = require('constants/queryKeys');
const { useQuery } = require('react-query');
const { exportDataServices } = require('services/exportData');

export const EXPORT_DATA_PAGE_SIZE = LIMIT;

export const useExportData = () => {
  const router = useRouter();
  const { assignees, isFetching: isAssigneesFetching } = useAssignees();
  const page = router.query?.page || 1;
  const pageSize = router.query?.pageSize || EXPORT_DATA_PAGE_SIZE;

  const exportDataJobsResponse = useQuery(
    [QUERY_KEYS.GET_EXPORT_DATA_KEY, { page, pageSize }],
    () => {
      const urlParams = getCleanedUrlParams({
        page,
        pageSize: parseInt(pageSize, 10) || EXPORT_DATA_PAGE_SIZE,
      });
      return exportDataServices.getExportDataJobs({ urlParams });
    }
  );

  const exportDataJobs = handleExportDataJobsData(
    exportDataJobsResponse?.data?.data || [],
    assignees
  );

  useEffect(() => {
    if (exportDataJobsResponse?.isError) {
      showError(exportDataJobsResponse?.error);
    }
  }, [exportDataJobsResponse?.isError]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    exportDataJobs,
    total: exportDataJobsResponse?.data?.meta?.total,
    loading: exportDataJobsResponse?.isFetching || isAssigneesFetching,
    page,
    pageSize: parseInt(pageSize, 10) || EXPORT_DATA_PAGE_SIZE,
    refresh: exportDataJobsResponse?.refetch,
  };
};
